import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import { TestimonialsRow, SingleTestimonial } from '../components/Testimonials';
import Pricing from '../components/Pricing';
import Gallery from '../components/Gallery';
import Availability from '../components/Availability';
import DepositPay from '../components/DepositPay';
import Vouchers from '../components/Vouchers';
import Contact from '../components/Contact';
import About from '../components/About';
import Reviews from '../components/Reviews';
import MyBookings from '../components/MyBookings';
import Footer from '../components/Footer';
import ConciergeChat from '../components/ConciergeChat';
import { testimonials, midTestimonials, contactInfo } from '../data/mock';
import { Toaster } from '../components/ui/toaster';
import { MessageCircle } from 'lucide-react';

const waPrefill = encodeURIComponent(
  "Hi Dawn! I'd love to book a treatment with Blissfull Mobile Spa. Could you share your availability?"
);

const Home = () => {
  return (
    <div
      className="relative min-h-screen w-full overflow-x-hidden"
      style={{
        background:
          'linear-gradient(135deg, #f4a48c 0%, #e9a0aa 25%, #d29ac1 55%, #b8a4d8 80%, #a5b0e6 100%)',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-rose-300/25 blur-3xl" />
        <div className="absolute top-1/2 -right-40 w-[500px] h-[500px] rounded-full bg-indigo-300/25 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 w-[500px] h-[500px] rounded-full bg-pink-200/20 blur-3xl" />
      </div>

      <div className="relative z-10">
        <Navbar />
        <Hero />
        <TestimonialsRow items={testimonials} />
        <Pricing />
        <SingleTestimonial item={midTestimonials[0]} />
        <About />
        <Gallery />
        <SingleTestimonial item={midTestimonials[2]} />
        <Availability />
        <DepositPay />
        <MyBookings />
        <Vouchers />
        <Reviews />
        <Contact />
        <SingleTestimonial item={midTestimonials[3]} />
        <Footer />
      </div>

      <a
        href={`https://wa.me/${contactInfo.whatsappIntl}?text=${waPrefill}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle size={26} strokeWidth={1.8} />
      </a>

      <ConciergeChat />

      <Toaster />
    </div>
  );
};

export default Home;
